<template>
	<div id="wjc-cc-calendar" v-cloak>
		<section id="wjccalendar" @keyup:space="previousMonth">
			<div class="calendar__block">
				<div class="calendar__header">
					<span class="calendar__button__holder">
						<span v-if="showBackButton()" class="calendar__button calendar__button--back icon-prev" @click="previousMonth">
							Back
						</span>
					</span>
					<h2 class="calendar__month" @click="showCalendar = !showCalendar">
						{{ monthStart | formatDate('MMMM YYYY') }}
					</h2>
					<span class="calendar__button__holder">
						<span v-if="showNextButton()" class="calendar__button calendar__button--next icon-next" @click="nextMonth">
							Next
						</span>
					</span>
				</div>
				<div class="calendar__body-container">
					<div class="calendar_day-container">
						<div v-for="name in dayNames" :key="name.id" class="calendar__item calendar__name">
							{{ name }}
						</div>
					</div>
					<transition v-bind:enter-active-class="enterActiveName" v-bind:leave-active-class="leaveActiveName" v-on:after-leave="showNextCalendar">
						<div v-if="showCalendar" class="calendar__body" key="a">
							<div v-for="(day, index) in days" :key="index" :data-date="day | formatDate('YYYY-MM-DD')" class="calendar__item" :class="{ today: today(day), active: hiliteDate(day), pastdate: beforeToday(day) }" :style="{ gridColumn: column(day, index) }">
								<span v-if="hiliteDate(day)">
									<a :href="'/calendar/calendar/' + dayDateLink(day) + '/'">{{ day | formatDate('D') }}</a>
								</span>
								<span v-else>
									{{ day | formatDate('D') }}
								</span>
							</div>
						</div>

					</transition>
				</div>
			</div>
			<div class="action-area">
				<div class="view-all">
					<a href="/calendar/" class="button">View All Events</a>
				</div>
			</div>
		</section>

		<section id="wjcevents">


			<div class="calendar__header">

				<h2 class="calendar__month" @click="showCalendar = !showCalendar">
					{{ monthStart | formatDate('MMMM YYYY') }}
				</h2>

			</div>
			<div class="event-wrapper">
				<fade-transition>
					<div class="loader" v-if="showLoader">
						<!-- Loader -->
						<svg version="1.1" id="L4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
							<circle fill="#28a4c3" stroke="none" cx="6" cy="50" r="6">
								<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1" />
							</circle>
							<circle fill="#28a4c3" stroke="none" cx="26" cy="50" r="6">
								<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.2" />
							</circle>
							<circle fill="#28a4c3" stroke="none" cx="46" cy="50" r="6">
								<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3" />
							</circle>
						</svg>

					</div>
				</fade-transition>
				<fade-transition>
					<div v-if="showListing" class="event-list">
						<div v-for="event in events" :key="event.id" class="event">
							<div class="event-info">
								<figure class="event-image">
									<a :href="event.url">
										<img :src="event.image.url" :alt="event.title">
									</a>
								</figure>
								<div class="event-detail">
									<h3 class="event-title h4" v-html='event.title'>
										<a :href="event.url">{{event.title}}</a>
										<span v-if="event.venue" v-html='event.venue'>{{event.venue}}</span>
									</h3>
									<span class="event-times">
										<span class="event-start-time">{{ formatDateFromString(event.start_date, 'h:mm A') }} </span>
										<span>-</span>
										<span class="event-end-time"> {{ formatDateFromString(event.end_date, 'h:mm A') }}</span>
									</span>
								</div>
								<div class="event-date">
									<span class="event-weekday">{{ formatDateFromString(event.start_date, 'ddd') }} </span>
									<span class="event-day">{{ formatDateFromString(event.start_date, 'DD') }} </span>
									<span class="event-month">{{ formatDateFromString(event.start_date, 'MMM') }} </span>
									<span class="event-year">{{ formatDateFromString(event.start_date, 'YYYY') }} </span>

								</div>
							</div>
						</div>
						<div v-if="noresults()" class="no-results">
							<h4>No results were found.</h4>
						</div>
						<div class="btn__control">
							<span class="calendar__button calendar__button--back icon-prev" @click="previousMonth">
								Back
							</span>
							<span class="calendar__button calendar__button--next icon-next" @click="nextMonth">
								Next
							</span>
						</div>
					</div>
				</fade-transition>
			</div>
		</section>
	</div>
</template>

<script>
import axios from "axios";
import dayjs from "dayjs";
import FadeTransition from "./FadeTransition.vue";
export default {
	name: 'App',
	components: {
		FadeTransition
	},
	data() {
		return {
			events: [],
			enterActiveName: "animated fadeInRight",
			leaveActiveName: "animated fadeOutLeft",
			month: "This month",
			showListing: false,
			showLoader: true,

			showCalendar: true,
			monthStart: null,
			monthEnd: null,
			apiRange: '',
			days: [],
			eventDays: [],
			dayNames: ["S", "M", "T", "W", "T", "F", "S"]
		}
	},
	methods: {
		beforeToday: function (day) {
			return (!dayjs().subtract(1, 'day').isBefore(day));
		},
		hiliteDate: function (day) {
			let numday = day.format('DD')
			let apiday = this.eventDays.filter(function (id) {
				return (id == numday);
			});
			if (apiday.length > 0) {
				return true;
			}
		},
		noresults: function () {
			if (this.events.length == 0) {
				return true;
			}
		},
		showBackButton: function () {
			return this.monthStart.isAfter(this.currentMonth, 'month');
		},

		showNextButton: function () {
			var range = dayjs().add(4, 'month');
			return this.monthStart.isBefore(range, 'month');
		},

		dayDateNum: function (day) {
			return day.format('DD')
		},
		dayDateLink: function (day) {
			return day.format('YYYY-MM-DD')
		},
		showCurrent: function (index) {
			document.getElementById(index).scrollIntoView();
		},
		fetchModernTribeEvents: function () {
			this.showListing = false;
			this.showLoader = true;
			this.apiRange = 'start_date=' + this.monthStart.format('YYYY-MM-DD') + '&end_date=' + this.monthEnd.format('YYYY-MM-DD');
			axios
				.get('/calendar/wp-json/tribe/events/v1/events/?' + this.apiRange + '&per_page=65')
				.then(response => {
					this.events = response.data.events.filter(function (el) {
						console.log(el.categories[0]);
						var inCategory = false;
						if (el.categories[0] != undefined && el.categories[0]['name'] == 'City Council') {
							inCategory = true;
						}

						return ((dayjs().isBefore(dayjs(el.start_date)) || dayjs().isSame(dayjs(el.start_date))) && inCategory);
					});

					this.eventDays = this.events.map(function (el) {
						return el.start_date_details.day;
					});
					this.showListing = true;
					this.showLoader = false;
				})
		},

		smoothScroll: function () {
			document.querySelectorAll('a[href^="#"]').forEach(anchor => {
				anchor.addEventListener('click', function (e) {
					e.preventDefault();

					document.querySelector(this.getAttribute('href')).scrollIntoView({
						behavior: 'smooth'
					});
				});
			});
		},



		formatDateFromString(string, format) {
			return dayjs(string).format(format);
		},
		column: function (date, index) {
			if (index !== 0) {
				return;
			}
			return (date.day() + 7) % 7 + 1;
		},
		today: function (day) {
			return dayjs().isSame(day, "day");
		},
		getNewDays: function () {
			const daysInMonth = this.monthStart.daysInMonth();
			this.days = [...Array(daysInMonth)].map((item, index) =>
				this.monthStart.add(index, "day")
			);
		},
		nextMonth: function () {
			this.enterActiveName = 'animated fadeInRight';
			this.leaveActiveName = 'animated fadeOutLeft';
			this.$nextTick(function () {
				this.updateNextMonth();
			});
		},
		updateNextMonth: function () {
			this.showCalendar = false;
			const currentMonth = this.monthStart;
			const newMonth = currentMonth.add(1, "month").startOf("month");
			this.monthStart = newMonth;
			this.monthEnd = this.monthStart.endOf("month");
			this.fetchModernTribeEvents();
			this.getNewDays();
		},
		previousMonth: function () {
			this.enterActiveName = 'animated fadeInLeft';
			this.leaveActiveName = 'animated fadeOutRight';
			this.$nextTick(function () {
				this.updatePreviousMonth();
			});
		},
		updatePreviousMonth: function () {
			this.showCalendar = false;
			const currentMonth = this.monthStart;
			const newMonth = currentMonth.subtract(1, "month").startOf("month");
			this.monthStart = newMonth;
			this.monthEnd = this.monthStart.endOf("month");
			this.fetchModernTribeEvents();
			this.getNewDays();
		},
		showNextCalendar: function () {
			this.showCalendar = true;
		},
		thisMonth: function () {
			if (dayjs().isBefore(this.monthStart)) {
				this.enterActiveName = 'animated fadeInLeft';
				this.leaveActiveName = 'animated fadeOutRight';
			} else {
				this.enterActiveName = 'animated fadeInRight';
				this.leaveActiveName = 'animated fadeOutLeft';
			}
			this.$nextTick(function () {
				this.showCalendar = false;
				this.monthStart = dayjs().startOf("month");
				this.getNewDays();
			})
		},
		handleKeyUp(event) {
			if (event.keyCode !== 37 && event.keyCode !== 39 && event.keyCode !== 84) {
				return;
			}
			switch (event.keyCode) {
				case 37:
					this.previousMonth();
					break;
				case 39:
					this.nextMonth();
					break;
				case 84:
					this.thisMonth();
					break;
			}
		}
	},
	filters: {
		formatDate: function (value, format) {
			return value.format ? value.format(format) : value;
		}
	},
	created() {
		this.monthStart = dayjs().startOf("month");
		this.monthEnd = this.monthStart.endOf("month");
		const daysInMonth = this.monthStart.daysInMonth();
		const daysArray = [...Array(daysInMonth)];
		this.days = daysArray.map((item, index) => this.monthStart.add(index, "day"));

		this.fetchModernTribeEvents();
	},
};

</script>


<style lang="scss">
.loader {
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 999;
	height: 100%;
}

#L4 {
	width: 6rem;
	height: auto;
}

#wjccalendar {
	margin: 0 auto;
}

.calendar__block {
	padding: 0 1rem;
	margin-bottom: 2rem;
}

.calendar__block {
	overflow: hidden;
	z-index: -2;
}

.calendar__header {
	padding: 0 1rem;
	margin: 0 -1rem;

	>* {
		margin: 1rem 0;
	}
}

.calendar__button {
	cursor: pointer;
}

.calendar_day-container {
	margin: 0 auto;
	display: grid;
	grid-template-columns: repeat(7, 1fr);
}

.calendar__body {
	margin: 0 auto;
	background-color: var(--wjc-bg-color);
	font-variant: tabular-nums;
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	grid-template-rows: repeat(6, 1fr);
	animation-duration: 300ms;
}

.calendar__body-container {
	display: flex;
	overflow: hidden;

	flex-direction: column;
}

.calendar__item {
	cursor: default;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	z-index: 1;
}

.active:after {
	content: '';
	position: absolute;
	width: 65%;
	height: 65%;
	background-color: var(--wjc-active);
	border-radius: var(--wjc-border-radius);
	z-index: -1;
}

.today:after {
	content: '';
	position: absolute;
	width: 65%;
	height: 65%;
	background-color: var(--wjc-today);
	border-radius: var(--wjc-border-radius);
	z-index: -1;
}
</style>
